var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Appnav'),_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }